import { Snackbar, Slide, Grid, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
/**
 *
 * @param {Bool} open
 * @param {String} message
 * @param {Object} closeSnackBar //close snackbar handler
 * @param {String} status //message status ["success", "failure"]
 */
const CustomSnackBar = ({ open, message, status, onClose }) => {
  return (
    <Snackbar
      open={open}
      message={message}
      TransitionComponent={TransitionLeft}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      key={"bottomcenter"}
    >
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          backgroundColor: "#050D2E",
          minWidth: "350px",
          maxWidth: "auto",
          borderRadius: "5px",
          height: "50px",
          px: 1,
        }}
      >
        <Grid item xs={1}>
          {status === "success" ? (
            <CheckCircleIcon sx={{ color: "green" }} />
          ) : (
            <CancelRoundedIcon sx={{ color: "red" }} />
          )}
        </Grid>
        <Grid item xs={10}>
          <Typography sx={{ color: "#ffffff", fontSize: ".875rem" }}>
            {message}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <ClearRoundedIcon
            sx={{ color: "#ffffff", cursor: "pointer" }}
            onClick={onClose}
          />
        </Grid>
      </Grid>
    </Snackbar>
  );
};

function TransitionLeft(props) {
  return <Slide {...props} direction="left" timeout={600} />;
}

export default CustomSnackBar;
